import { faTimesCircle, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MDBCol, MDBContainer, MDBRow } from 'mdbreact';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Button, Card, Input, Modal, Spinner } from 'react-rainbow-components';
import { Link, useHistory } from 'react-router-dom';
import { propsPreview } from '../../../interfaces/Info_interface';
import { NotificationProps } from '../../../interfaces/Notification_interface';
import { Role } from '../../../interfaces/User_interface'
import CustomLoader from '../Customloader';
import ShowNotification from '../Notification';
import { RequestInit, RequestInitWithBody } from '../RequestInit';
import { customStyles } from './styles';


interface DatatableProps {
    props: {
        adminRole: Role | undefined,
        type: 'agenda' | 'actualite'
    }

}

const FilterComponent = ({ filterText, onFilter, onClear }: any) => (
    <>
            <MDBRow className='mb-2 mt-4' center={true}>
                <MDBCol md='12' className='px-0'>
                <Input id="search" type="text" placeholder="Rechercher par titre" aria-label="Search Input" value={filterText} onChange={onFilter} onClick={onClear} iconPosition='right' icon={<FontAwesomeIcon className="color-red" onClick={onClear} icon={faTimesCircle} size='2x' />} />
                </MDBCol>
            </MDBRow>
    </>
);

const CustomDatatable: React.FC<DatatableProps> = (props: DatatableProps) => {

    const [filterText, setFilterText] = useState<string>('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState<boolean>(false);
    const [pending, setPending] = useState(true);
    //const [data, setData] = useState<propsPreview>({Titre:'',Commune:{Id:0,name:''},DateDebut:'',DateFin:'',Image:'',TextComplet:'',DateEvenement:'',TextPreview:''})
    const [data, setData] = useState<any>([{}])
    const [showConfirm, setShowConfirm] = useState<boolean>(false)
    const [todelete, setTodelete] = useState<number | undefined>(undefined)
    const history = useHistory<NotificationProps>();

    const fetchData = async() => {
        const request = await fetch(`${props.props.type === 'actualite' ? 'https://admin.radioemotion.be/api/actualite/getall' : 'https://admin.radioemotion.be/api/agenda/getall'}`, RequestInit as RequestInit);
        const data = await request.json();
        console.log(data.data)
        if (data.response) {
            setData(data.data)
            setPending(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])


    const deleteRow = (Id: number | undefined, confirmed: boolean) => {
        async function deleteRow() {
            const request = await fetch(`${props.props.type === 'actualite' ? 'https://admin.radioemotion.be/api/actualite/delete' : 'https://admin.radioemotion.be/api/agenda/delete'}`, RequestInitWithBody({ body: { Id: Id }, type: 'DELETE' }) as RequestInit);
            const response = await request.json();
            if (response.response) {
                fetchData()
            }
        }
        if (confirmed) {
            deleteRow()
        }
        setTodelete(undefined)
    }


    const filteredItems = data.filter((item: any) => item.Titre && item.Titre.toLowerCase().includes(filterText.toLowerCase()));
    const handleClear = () => {
        if (filterText) {
            setResetPaginationToggle(!resetPaginationToggle);
            setFilterText('');
        }
    };

    return (
        <>
         {history.location.state && history.location.state.passed === true ?
                <ShowNotification
                icon="check"
                iconClassName="success-dark-text"
                bodyClassName="px-5 font-weight-bold text-white success-color-dark"
                autohide={5000}
                title=""
                message={history.location.state.message}
                text="maintenant"
                />
                : null
            }
            <Modal
                id="confirmDelete"
                title="Voulez-vous vraiment supprimer ?"
                isOpen={showConfirm}
                onRequestClose={() => { setShowConfirm(!showConfirm); setTodelete(undefined); }}
            >
                <div className="d-flex justify-content-between mt-5">
                    <Button variant='brand' label='Annuler' onClick={() => setShowConfirm(false)} />
                    <Button variant='brand' label='Confirmer' onClick={() => { setShowConfirm(false); deleteRow(todelete, true) }} />

                </div>

            </Modal>

                <DataTable
                    pointerOnHover={true}
                    data={filteredItems}
                    subHeader={true}
                    noHeader={true}
                    customStyles={customStyles}
                    subHeaderComponent={<FilterComponent onFilter={(e: any) => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />}
                    progressPending={pending}
                    progressComponent={<CustomLoader />}
                    pagination={true}
                    className="datatable"
                    columns={props.props.adminRole?.crud === 1 ? 
                        [{
                            name: `ID`,
                            selector: `${props.props.type === 'actualite'  }`,
                            sortable: true,
                            width: '5%',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Id}</Link></>
                        },
                        {
                            name: `Titre`,
                            selector: `Titre`,
                            sortable: true,
                            width: '29%',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Titre}</Link></>
    
                        },
    
                        {
                            name: `Date de debut`,
                            selector: `Date_Debut`,
                            sortable: true,
                            width: '13',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Date_Debut}</Link></>
    
                        },
                        {
                            name: `${props.props.type === 'actualite' ? 'Date de fin' : "Date d'evenement"}`,
                            selector: `${props.props.type === 'actualite' ? 'Date_Fin' : 'Date_Evenement'}`,
                            sortable: true,
                            width: '13',
                            cell: row => <>{props.props.type === 'actualite' ?
                                <Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Date_Fin}</Link> :
                                <Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Date_Evenement}</Link>}</>
                        },
                        {
                            name: `Commune`,
                            selector: `Commune`,
                            sortable: true,
                            width: '12',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Commune}</Link></>
    
                        },
                        {
                            name: `Créé par`,
                            selector: `Created_By`,
                            sortable: true,
                            width: '12%',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Created_By}</Link></>
    
                        },
                        {
                            name: `Image`,
                            selector: `Photo`,
                            width: '13',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }}><Card className="my-2">  <img className="rounded w-100" alt={row.Photo} src={row.Photo} /></Card></Link></>
                        },
                        {
                            name: 'Delete',
                            selector: 'Delete',
                            width: '6%',
                            cell: row => <>{props.props.adminRole?.delete === 1 ? <FontAwesomeIcon icon={faTrashAlt} onClick={() => { setShowConfirm(true); setTodelete(row.Id) }} className="font-size-1vw mx-auto"></FontAwesomeIcon> : <></>}</>
                        }]: 
                    
                        props.props.adminRole?.update === 1 && props.props.adminRole.delete === 0 ? 
                        
                        [{
                            name: `ID`,
                            selector: `Id`,
                            sortable: true,
                            width: '5%',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Id}</Link></>
                        },
                        {
                            name: `Titre`,
                            selector: `Titre`,
                            sortable: true,
                            width: '29%',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Titre}</Link></>
    
                        },
    
                        {
                            name: `Date de debut`,
                            selector: `Date_Debut`,
                            sortable: true,
                            width: '13',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Date_Debut}</Link></>
    
                        },
                        {
                            name: `${props.props.type === 'actualite' ? 'Date de fin' : "Date d'evenement"}`,
                            selector: `${props.props.type === 'actualite' ? 'Date_Fin' : 'Date_Evenement'}`,
                            sortable: true,
                            width: '13',
                            cell: row => <>{props.props.type === 'actualite' ?
                                <Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Date_Fin}</Link> :
                                <Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Date_Evenement}</Link>}</>
                        },
                        {
                            name: `Commune`,
                            selector: `Commune`,
                            sortable: true,
                            width: '12',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Commune}</Link></>
    
                        },
                        {
                            name: `Créé par`,
                            selector: `Created_By`,
                            sortable: true,
                            width: '12%',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Created_By}</Link></>
    
                        },
                        {
                            name: `Image`,
                            selector: `Photo`,
                            width: '13',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} ><Card className="my-2">  <img className="rounded w-100" alt={row.Photo} src={row.Photo} /></Card></Link></>
                        }] :
                        
                        
                        props.props.adminRole?.update === 1 && props.props.adminRole.delete === 0 ? 
                        
                        [{
                            name: `ID`,
                            selector: `Id`,
                            sortable: true,
                            width: '5%',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Id}</Link></>
                        },
                        {
                            name: `Titre`,
                            selector: `Titre`,
                            sortable: true,
                            width: '29%',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Titre}</Link></>
    
                        },
    
                        {
                            name: `Date de debut`,
                            selector: `Date_Debut`,
                            sortable: true,
                            width: '13',
                            cell: row => <><Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Date_Debut}</Link></>
    
                        },
                        {
                            name: `${props.props.type === 'actualite' ? 'Date de fin' : "Date d'evenement"}`,
                            selector: `${props.props.type === 'actualite' ? 'Date_Fin' : 'Date_Evenement'}`,
                            sortable: true,
                            width: '13',
                            cell: row => <>{props.props.type === 'actualite' ?
                                <Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Date_Fin}</Link> :
                                <Link to={{ pathname: `/${props.props.type}/edit`, state: { row } }} className="font-size-0dot65vw">{row.Date_Evenement}</Link>}</>
                        },
                        {
                            name: `Commune`,
                            selector: `Commune`,
                            sortable: true,
                            width: '12',
                            cell: row => <p className="font-size-0dot65vw">{row.Commune}</p>
    
                        },
                        {
                            name: `Créé par`,
                            selector: `Created_By`,
                            sortable: true,
                            width: '12%',
                            cell: row => <p className="font-size-0dot65vw">{row.Created_By}</p>
    
                        },
                        {
                            name: `Image`,
                            selector: `Photo`,
                            width: '13',
                            cell: row => <><Card className="my-2">  <img className="rounded w-100" alt={row.Photo} src={row.Photo} /></Card></>
                        },
                        {
                            name: 'Delete',
                            selector: 'Delete',
                            width: '6%',
                            cell: row => <><FontAwesomeIcon icon={faTrashAlt} onClick={() =>{ setShowConfirm(true); setTodelete(row.Id) }} className="font-size-1vw mx-auto"></FontAwesomeIcon> : </>
                        }]
                        
                        : []
                        
                    
                    }
                    
                />
</>
       
    )
}
export default CustomDatatable;
